/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Product finish matte or gloss
 */
export enum Finish {
  MATTE = 'matte',
  GLOSS = 'gloss',
}
